import Appsignal from '@appsignal/javascript'
import { appsignalKey, appsignalRevision } from './configuration'

export const appsignal = new Appsignal({
  key: appsignalKey || '',
  revision: appsignalRevision || '',
})

export function sendError(error, action, tags = {}) {
  appsignal.sendError(error, (span) => {
    span.setAction(action)
    tags.location = document.location.toString()
    span.setTags(tags)
  })
}
